import { Link } from "react-router-dom";
import { categories } from "@/mocks/videos";

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="font-heading text-xl text-background-50 mb-4">
              <Link to="/" className="cursor-pointer hover:text-primary-400 transition-colors">久久视频</Link>
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              久久视频聚合蜜桃视频、樱桃视频、蘑菇视频、茄子视频等泛娱乐内容，免费在线看综艺、动漫、短视频、搞笑创意视频，轻松刷不停。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">特色频道</h4>
            <ul className="space-y-2.5">
              {categories.slice(4).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-background-50 mb-4">关于我们</h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors"
                >
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors"
                >
                  联系我们
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-background-400 hover:text-primary-400 cursor-pointer transition-colors"
                >
                  常见问题
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 久久视频 Jiujiu Video. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-primary-400 hover:bg-background-700 cursor-pointer transition-all" rel="nofollow">
              <i className="ri-wechat-line"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-primary-400 hover:bg-background-700 cursor-pointer transition-all" rel="nofollow">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-400 hover:text-primary-400 hover:bg-background-700 cursor-pointer transition-all" rel="nofollow">
              <i className="ri-bilibili-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}